export default "__VITE_ASSET__KRrM8PfD__"